import React, { useState } from "react";
import CustomFilters from "../../../core/custom-filters";
import { Box } from "@mui/material";
import SiTextField from "../../../core/si-textfield";
import { PAGE_LIMIT } from "../../../utils";

const StockDetailsFilters = ({ loadData, setMainFilters, filter }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [endDate, setEndDate] = useState("");

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else if (key === "createdAt") {
          payload["startDate"] = filters[key];
          if (endDate) {
            payload["endDate"] = endDate;
          }
        } else {
          payload[key] = filters[key];
        }
      }
      if (setMainFilters) {
        setMainFilters(payload);
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
      });
    } else {
      if (setMainFilters) {
        setMainFilters({});
      }
      loadData({ sortBy: "-createdAt", limit: PAGE_LIMIT, page: 1 });
    }
  };

  const filterTypes = [
    { label: "Filter by Status", value: "status" },
    { label: "Filter by List Number", value: "listNumber" },
    { label: "Filter by Plant", value: "plant" },
    { label: "Filter by Serial Number", value: "serialNumber" },
    { label: "Filter by Model", value: "model" },
    { label: "Filter by Created Date", value: "createdAt" },
  ];

  const renderFilterInput = () => {
    switch (filterType) {
      case "status":
        return (
          <SiTextField
            placeholder="Status"
            name="status"
            onChange={handleFilterValueChange}
          />
        );
      case "listNumber":
        return (
          <SiTextField
            placeholder="List Number"
            name="listNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "plant":
        return (
          <SiTextField
            placeholder="Plant"
            name="plant"
            onChange={handleFilterValueChange}
          />
        );
      case "serialNumber":
        return (
          <SiTextField
            placeholder="Serial Number"
            name="serialNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "model":
        return (
          <SiTextField
            placeholder="Model"
            name="model"
            onChange={handleFilterValueChange}
          />
        );
      case "createdAt":
        return (
          <Box sx={{ display: "flex", gap: "20px" }}>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>Start Date</p>
              <SiTextField
                placeholder="Start Date"
                name="startDate"
                type="date"
                onChange={handleFilterValueChange}
                sx={{ mt: 1 }}
              />
            </div>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>End Date</p>
              <SiTextField
                placeholder="End Date"
                name="endDate"
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ mt: 1 }}
              />
            </div>
          </Box>
        );
      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default StockDetailsFilters;
